import React, { forwardRef, useEffect, useLayoutEffect, useRef } from 'react'
import Quill from 'quill'

const RichTextEditor = forwardRef(
  ({ readOnly, defaultValue, onTextChange, onSelectionChange }, ref) => {
    const containerRef = useRef(null)
    const defaultValueRef = useRef(defaultValue)
    const onTextChangeRef = useRef(onTextChange)
    const onSelectionChangeRef = useRef(onSelectionChange)

    useLayoutEffect(() => {
      onTextChangeRef.current = onTextChange
      onSelectionChangeRef.current = onSelectionChange
    })

    useEffect(() => {
      ref.current?.enable(!readOnly)
    }, [ref, readOnly])

    useEffect(() => {
      const container = containerRef.current

      const newDiv = container.ownerDocument.createElement('div')
      const editorContainer = container.appendChild(newDiv)

      const quill = new Quill(editorContainer, {
        modules: {
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'blockquote', 'code-block'],
          ],
          keyboard: {
            bindings: {
              tab: {
                key: 'Tab',
                handler: () => true,
              },
            },
          },
        },
        theme: 'snow',
      })

      ref.current = quill

      if (defaultValueRef.current) {
        quill.setContents(defaultValueRef.current)
      }

      quill.on(Quill.events.TEXT_CHANGE, (...args) => {
        onTextChangeRef.current?.(...args)
      })

      quill.on(Quill.events.SELECTION_CHANGE, (...args) => {
        onSelectionChangeRef.current?.(...args)
      })

      return () => {
        ref.current = null
        container.innerHTML = ''
      }
    }, [ref])

    return <div className="[&_.ql-editor]:min-h-40" ref={containerRef}></div>
  },
)

RichTextEditor.displayName = 'RichTextEditor'

export default RichTextEditor
